<template>
  <div id="app" class="container justify-content-center flex-column">
    <div style="height: 50px">
      <button @click="goBack" id="backBtn"> < </button>
    </div>
    <Preloader />
    <router-view v-if="isAuthorized" class="container justify-content-center mt-5 p-4 flex-column"/>
    <div v-else>
      <h1>Kirish rad etildi</h1>
      <p>Ushbu ilovadan foydalanishga ruxsat etilgan foydalanuvchilar ro'yxatida yoʻqsiz.</p>
    </div>
  </div>
</template>

<script setup>
import Preloader from "@/components/Preloader.vue";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const allowedUsers = [
  96422899, //men
  188228695,// Bobir aka
  765184110,//umar
  6365810018,//otabek
];

const goBack = () =>{
    router.back();
};

const user = ref(null);
const isAuthorized = ref(false);

onMounted(() => {
  window.Telegram.WebApp.ready();
  if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp;

    // Expand Web App to full screen
    tg.expand();

    // Get User Data
    const initDataUnsafe = tg.initDataUnsafe;

    if (initDataUnsafe?.user) {
      user.value = initDataUnsafe.user;
      isAuthorized.value = allowedUsers.includes(user.value.id);
    }
    else if(localStorage.getItem("telegram_auth") === 'cozingo')
    {
      isAuthorized.value = true;
    }
  }
});

</script>

<style>
#preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
#backBtn{
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 0;
  background: #ccc;
  border-radius: 30px;
  font-size: 20px;
  color: #fff;
  position: absolute;
  top: 10px;
  left: 10px
}
</style>